import { Component, Input, Output, EventEmitter } from '@angular/core';

export type RadioSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() error: boolean = false;
  @Input() size: RadioSize = 'medium';
  @Input() label: string = '';
  @Input() id: string = '';

  radioId: string = `radio-${Math.random().toString(36).substr(2, 9)}`;

  @Output() change = new EventEmitter<boolean>();

  get radioClasses(): string {
    const classes = ['radio-button'];
    if (this.checked) classes.push('checked');
    if (this.disabled) classes.push('disabled');
    if (this.error) classes.push('error');
    classes.push(`size-${this.size}`);
    return classes.join(' ');
  }

  onRadioChange(): void {
    if (!this.disabled) {
      this.change.emit(!this.checked);
    }
  }
}
